/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';

import PropTypes from 'prop-types';

import { Menu } from '@material-ui/core';

import ColorInput from '~/components/ColorInput';
import LocaleMessage from '~/components/LocaleMessage';

import lists from '~/config/Lists';

export default function ColorSettings({
    pageColors,
    setPageColors,
    theme,
    colors,
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [colorPicker, setColorPicker] = useState({
        visible: false,
        colors: pageColors || {},
        selector: 'top',
    });

    function handleColorClick(event, selector) {
        setAnchorEl(event.currentTarget);

        setColorPicker({
            ...colorPicker,
            selector,
            visible: !colorPicker.visible,
        });
    }

    function handleColorClose() {
        setColorPicker({ ...colorPicker, visible: false });
    }

    function handleColorChange(c) {
        const sel_color = c.hex;
        const _colors = colorPicker.colors;
        _colors[colorPicker.selector] = sel_color;
        setColorPicker({ ...colorPicker, colors: _colors });
        setPageColors({
            ...pageColors,
            [colorPicker.selector]: sel_color,
        });
        // setPageSettings('colors', {
        //     ...pageColors,
        //     [colorPicker.selector]: sel_color,
        // });
    }

    return (
        <div className="col-12 mb-3">
            {colorPicker.visible && anchorEl ? (
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={colorPicker.visible}
                    onClose={() => handleColorClose()}
                >
                    <SketchPicker
                        color={
                            pageColors[colorPicker.selector] ||
                            colorPicker.colors[colorPicker.selector]
                        }
                        onChange={color => handleColorChange(color)}
                        onChangeComplete={color => {
                            handleColorChange(color);
                        }}
                        disableAlpha
                        presetColors={
                            theme
                                ? [
                                      theme.primary,
                                      theme.secondary,
                                      ...lists.default_colors,
                                  ]
                                : null
                        }
                    />
                </Menu>
            ) : null}

            <div className="mb-3">
                <LocaleMessage msg="label.form.colors" />
            </div>
            <div className="">
                {colors.map(c => (
                    <ColorInput
                        margin="mb-3"
                        key={`color_${c.id}`}
                        title={<LocaleMessage msg={c.title} />}
                        color={pageColors[c.id] || c.default}
                        handleColorClick={event =>
                            handleColorClick(event, c.id)
                        }
                    />
                ))}
            </div>
        </div>
    );
}

ColorSettings.defaultProps = {
    colors: [],
    pageColors: {},
};

ColorSettings.propTypes = {
    colors: PropTypes.array,
    pageColors: PropTypes.object,
    setPageColors: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
};
